import bgImage from "images/howdy_box/howdy-box-bg.png"
import lessonPlanImage from "images/howdy_box/howdy-box-lesson-plan.png";
import mediaImage from "images/howdy_box/howdy-box-video.png";
import resourcesImage from "images/howdy_box/howdy-box-resource.png";
import aiToolsImage from "images/howdy_box/ai_tools.png"
import posthog from "posthog-js";
import { PH_EVENTS } from "js/posthog_analytics";
import { AI_TAB_TITLE } from "js/searches/tabs/search_tab";

const HOWDY_OPTIONS = [
  {
    key: "ai_lesson_plans",
    label1: "Create a",
    label2: "lesson plan",
    tabTitle: AI_TAB_TITLE,
    image: lessonPlanImage,
    aiToolOption: {
      name: LP.config.howdy_box_ai_tool_name,
      id: LP.config.howdy_box_ai_tool_id
    },
    postHogEvent: PH_EVENTS.VISITOR.SELECTED_ONE_TOOL,
    postHogEventParams: { tool_name: "lesson_plans" },
  },
  {
    key: "ai_tools_list",
    label1: "Generate resources with",
    label2: "AI teacher tools",
    tabTitle: AI_TAB_TITLE,
    image: aiToolsImage,
    postHogEvent: PH_EVENTS.VISITOR.SELECTED_TOOL_LIST
  },
  {
    key: "media",
    label1: "Search 2 million",
    label2: "educational videos",
    tabTitle: "Media",
    image: mediaImage,
    postHogEvent: PH_EVENTS.VISITOR.SELECTED_SEARCH_VIDEOS,
    postHogEventParams: { search_term: "" },
  },
  {
    key: "resources",
    label1: "Find a teaching",
    label2: "resource",
    tabTitle: "Resources",
    image: resourcesImage,
    postHogEvent: PH_EVENTS.VISITOR.SELECTED_SEARCH_RESOURCES,
    postHogEventParams: { search_term: "" },
  },
];
const howdyBoxTitle = "Hi, What do you want to do?";

const HowdyBox = ({
  howdyBoxClassName = "",
  activeTab = null,
  aiToolParam = null,
  onClick
}) => {
  function getIsActive(option, activeTab, aiToolParam) {
    if (!activeTab) return false;

    const isCurrentTab = option.tabTitle === activeTab.title;

    if (option.aiToolOption) {
      return isCurrentTab && option.aiToolOption.name === aiToolParam;
    }
    if (option.key === "ai_tools_list" && isCurrentTab) {
      return !aiToolParam;
    }

    return isCurrentTab;
  }

  const getUrlParams = () => new URLSearchParams(window.location.search);

  const handleOptionClick = (option, onClick) => {
    let eventParams = option.postHogEventParams ? { ...option.postHogEventParams } : {};

    if (eventParams.hasOwnProperty("search_term")) {
      const keywordsParam = getUrlParams().get("keywords")
      eventParams.search_term = keywordsParam;
    }

    if (option.postHogEvent) {
      posthog.capture(option.postHogEvent, eventParams);
    }

    onClick(option);
  };

  return (
    <div
      className={`howdy-box relative flex flex-col lg:flex-row justify-center items-center gap-6 ${howdyBoxClassName} mb-8 max-w-full lg:max-w-9xl mx-auto h-auto lg:h-[400px] px-4 lg:px-20 py-6 lg:py-0`}
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      }}
    >
      <div className="w-full mb-4 lg:mb-0 lg:w-auto lg:absolute lg:top-4 lg:left-4 z-10">
        <span className="inline-block text-white font-extrabold text-xl lg:text-2xl px-4 py-2 tracking-wide drop-shadow-lg">
          {howdyBoxTitle}
        </span>
      </div>
      {HOWDY_OPTIONS.map(option => {
        const isActive = getIsActive(option, activeTab, aiToolParam);

        return (
          <button
            key={option.key}
            className={`howdy-option w-full lg:w-64 h-32 lg:h-64 flex flex-col items-center justify-center px-4 rounded-xl border transition overflow-hidden flex-1 min-h-0
              ${isActive
                ? "bg-blue-100 border-blue-500 text-blue-700 font-bold shadow-lg"
                : "bg-white border-gray-300 text-gray-700 hover:bg-blue-50 hover:border-blue-400"
              }`}
            onClick={() => handleOptionClick(option, onClick)}
            type="button"
          >
            <div className="flex flex-row lg:flex-col items-center w-full h-full">
              <img
                src={option.image}
                alt={`${option.label1} ${option.label2}`}
                className="w-20 h-20 lg:w-40 lg:h-40 xl:w-48 xl:h-48 rounded object-contain mr-3 lg:mr-0 flex-shrink-0"
              />
              <span className="font-semibold text-lg lg:text-base xl:text-lg text-center w-full break-words whitespace-normal">
                <span className="2xl:block">{option.label1}</span>
                <span className="2xl:hidden"> </span>
                <span className="2xl:block">{option.label2}</span>
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default HowdyBox;
